module.exports = __webpack_public_path__ + "img/codepen.befa7ace.svg";